import React from 'react';
import { useCallback, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  setCheckInId,
  updatePracticeStatus,
} from '../../redux/features/Practice';
import {
  UNSAFE_NavigationContext as NavigationContext,
  useNavigate,
} from 'react-router-dom';
import { destroyUser } from '../../redux/features/User';
import { Toast as CustomToast } from '../../Components';
import { toast } from 'material-react-toastify';
import { isMalaysian } from '../../utils';

export function useBlocker(blocker, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;
    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
}

export default function usePrompt(message, when, openCancelPopUp, user) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const blocker = useCallback(
    async (tx) => {
      if (
        await ((tx.location?.state?.from === 'bottomNavigation' &&
          openCancelPopUp(tx.location?.state?.to)) ||
          (tx.action === 'POP' && openCancelPopUp('Logistics Home Screen')))
      ) {
        if (!isMalaysian(user?.country)) {
          const payload = {
            userId: user.id,
            order: {
              old_status: 'arrived',
            },
            riders: {
              status: 'en-route',
            },
          };
          dispatch(setCheckInId(0));
          await dispatch(updatePracticeStatus(payload))
            .unwrap()
            .then(() => {
              if (tx.location?.state?.from === 'bottomNavigation') {
                navigate(tx.location.pathname);
              } else {
                navigate('/logistics');
              }
            })
            .catch((err) => {
              if (
                err?.error ===
                'You need to sign in or sign up before continuing.'
              ) {
                toast(
                  <CustomToast
                    severity="warning"
                    message="Your session has been expired"
                  />,
                  { closeButton: false }
                );
                dispatch(destroyUser());
                navigate('/login');
              }
            });
        } else {
          if (tx.location?.state?.from === 'bottomNavigation') {
            navigate(tx.location.pathname);
          } else {
            navigate('/logistics');
          }
        }
      } else if (
        tx.location?.state?.from !== 'bottomNavigation' &&
        tx.action === 'PUSH'
      ) {
        tx.retry();
      }
    },
    [message]
  );
  useBlocker(blocker, when);
}
